const EQ_0 = 'EQ_0'
const NEQ_0 = 'NEQ_0'

const options = {
  EQ_0: {
    class: 'eq-0',
    comparator: (value) => value === 0,
    operator: 'custom',
    parameters: [
      {
        operator: 'eq',
        text: '0',
        value: 0,
      },
    ],
    text: 'EQ 0',
    value: EQ_0,
  },
  NEQ_0: {
    class: 'neq-0',
    comparator: (value) => value !== 0,
    operator: 'custom',
    parameters: [
      {
        operator: 'neq',
        text: '0',
        value: 0,
      },
    ],
    text: 'NEQ 0',
    value: NEQ_0,
  },
}

export default options
